import * as u from './utils';
import Cookies from 'js-cookie';

export default () => {
    const downloads = document.querySelectorAll('a[data-download-type]');
    let contactId;
    let fileUrl;
    let downloadType;
    let downloadSku;

    let loggedInUserRequestSent = false;
    const loggedInUserFileBacklog = [];

    if (!downloads) {
        return;
    }

    if (WP.downloadTrackingMode === 'csv') {
        contactId = Cookies.get('csv-contact-id-2');
    } else {
        contactId = Cookies.get('hubspot-contact-id');
    }

    const storeContactId = (newContactId) => {
        // Store Id for user in this page load
        contactId = newContactId;

        // Potentially save HubSpot Contact ID cookie
        if (WP.downloadTrackingMode === 'csv') {
            Cookies.set('csv-contact-id-2', contactId, { expires: 365 });
        } else {
            Cookies.set('hubspot-contact-id', contactId, { expires: 365 });
        }
    };

    const logDownloadAction = () => {
        // Format request data
        const data = new FormData();
        data.append('security', WP.nonce);
        if (WP.downloadTrackingMode === 'csv') {
            data.append('action', 'csv_store_download');
        } else {
            data.append('action', 'hubspot_send_action');
        }
        data.append('contact_id', contactId);
        data.append('download_type', downloadType);

        if (Object.hasOwn(WP, 'product_sku')) {
            data.append('product', WP.product_sku);
        }

        if (downloadSku !== null) {
            data.append('product', downloadSku);
        }

        // Send the request

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        });

        const marketingInfoSent = new Event('marketing-info-sent');
        document.body.dispatchEvent(marketingInfoSent);
    };

    const loadUserContactId = () => {
        if (loggedInUserRequestSent) {
            return false;
        }

        loggedInUserRequestSent = true;

        // Format request data
        const data = new FormData();
        data.append('security', WP.nonce);
        if (WP.downloadTrackingMode === 'csv') {
            data.append('action', 'csv_load_user_contact_id');
        } else {
            data.append('action', 'hubspot_load_user_contact_id');
        }

        // Send the request

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (response.success && response.data.contact_id) {
                    storeContactId(response.data.contact_id);

                    const downloadTypes = [...new Set(loggedInUserFileBacklog)];
                    for (let i = 0; i < downloadTypes.length; i++) {
                        downloadType = downloadTypes[i];
                        logDownloadAction();
                    }
                }
            })
            .catch(() => {});
    };

    const handleFormCompletion = (e) => {
        // Trigger download
        setTimeout(() => {
            u.downloadFile(fileUrl);
        }, 2000);

        // If there was a problem and we never received a contact ID don;t continue
        if (!e.detail || !e.detail.contactId) {
            return;
        }

        // Store the contact ID
        storeContactId(e.detail.contactId);

        // Send the details of the user and download to HubSpot
        logDownloadAction();
    };

    const handleClick = (e) => {
        fileUrl = e.currentTarget.getAttribute('href');
        downloadType = e.currentTarget.dataset.downloadType;
        downloadSku = e.currentTarget.dataset.productSku ? e.currentTarget.dataset.productSku : null;

        if (contactId === undefined && !u.hasClass(document.body, 'logged-in')) {
            e.preventDefault();

            // Open Modal to take details
            u.addClass(document.querySelector('.marketing-popup'), 'is-active');

            // Set forms file url to the correct url
            document.querySelector('.marketing-popup input[name="file_url"]').value = fileUrl;

            const marketingFormLoad = new Event('marketing-form-load');
            document.body.dispatchEvent(marketingFormLoad);
        } else if (contactId === undefined) {
            // Add file to send to backlog
            loggedInUserFileBacklog.push(downloadType);

            // Request the logged in users contact ID
            loadUserContactId();
        } else {
            // Send the details of the user and download to HubSpot
            logDownloadAction();
        }
    };

    document.body.addEventListener('marketing-form-submission', handleFormCompletion);

    for (const el of downloads) {
        el.addEventListener('click', handleClick);
    }
};
